import "./firebricks.scss";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from "react-helmet";


export default function Firebricks() {
    const img = [
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731583477/firebrick_new2_ejrawc.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731583266/firebrick_new_ujz8fy.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731583769/firebrick_new3_z6ucxg.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731583829/firebrick_new4_zlmros.jpg"
    ]
    const [currentImg, setCurrentImg] = useState(0)
  return (

    <div className='main_wrapper'>
        <Helmet>
        <title>Fire Bricks || Raydron, Lagos, Nigeria</title>
        <meta name="description" content="Fire bricks, also known as refractory bricks, are a type of brick specifically designed to withstand high temperatures and are commonly used in applications involving intense heat, like fireplaces, furnaces, ovens, and kilns. Made from refractory ceramic materials, fire bricks are able to endure thermal cycling without cracking or breaking and retain their strength under extreme heat."/>
        <meta name="keywords" content="fire bricks, firebricks, refractory bricks, arch bricks, Lagos Nigeria" />
        </Helmet>
        <h3>Fire Bricks</h3>
        <div className='product_wrapper'>
            <div className="image_column">
                <div className="main_image">
                    <img className = 'imgMain' src={img[currentImg]} alt="product_image" />
                </div>
                <div className="slider_image_row">
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[0]} alt="product_image" onClick={(e)=>(setCurrentImg(0))}/>
                    </div>    
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[1]} alt="product_image" onClick={(e)=>(setCurrentImg(1))}/>
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[2]} alt="product_image"  onClick={(e)=>(setCurrentImg(2))} />
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[3]} alt="product_image"  onClick={(e)=>(setCurrentImg(3))} />
                    </div>
                </div>

            </div>
            <div className="description">
                <p className='text'>
                Key Characteristics of Our Fire Bricks:
                </p>
                <ul>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Withstand up to  1,800°C. 
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Highly insulating
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Resistant to thermal shock
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Resistant to chemicals
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Durable
                    </li>
                </ul>
                <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAP">Chat Us to Buy</button></a>
            </div>
        </div>
        <div className="details">
                Fire bricks, also known as refractory bricks, are a type of brick specifically designed to withstand high temperatures and are commonly used in applications involving intense heat, like fireplaces, furnaces, ovens, and kilns. Made from refractory ceramic materials, fire bricks are able to endure thermal cycling without cracking or breaking and retain their strength under extreme heat. 
                </div>
    </div>
  )
}
